/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import ButtonWithIcon from 'apps/ButtonWithIcon'
import LocalizationText from 'apps/LocalizationText'
import * as styles from './Alert.scss'

const cx = classNames.bind(styles)

interface IParam {
  id: string,
}

interface IProps {
  id: string,
  type: string,
  headline: string,
  message: string,
  onDismiss: (param: IParam) => void,
  timeout?: number,
}

class Alert extends React.Component<IProps, {}> {
  public componentDidMount () {
    const { timeout } = this.props
    if (timeout) {
      setTimeout(this.onDismiss, timeout)
    }
  }

  private onDismiss = () => {
    const { onDismiss, id } = this.props

    onDismiss({ id })
  }

  public render () {
    const { type, headline, message } = this.props
    return (
      <div>
        <div className={cx('root', type)}>
          <div className={styles.close}>
            <ButtonWithIcon
              iconName='warning'
              styleType='noStyle'
              onClick={this.onDismiss}
            />
          </div>
          <h4 className={styles.headline}>{headline}</h4>
          <div className={styles.body}>
            <LocalizationText>{message}</LocalizationText>
          </div>
        </div>
      </div>
    )
  }
}

export default Alert
